import {Injectable} from '@angular/core';
import {HammerGestureConfig} from '@angular/platform-browser';

const DIRECTION_UP = 8;
const DIRECTION_DOWN = 16;

// tslint:disable-next-line:no-bitwise
const DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
@Injectable()
export class NumberPickerHammerConfig extends HammerGestureConfig {
    overrides = {
        pan: {threshold: 1, pointers: 1, direction: DIRECTION_VERTICAL},
    } as any
}
